export default function resizeWindow() {
  const widthOfDisplay = document.body.clientWidth
  /* eslint-disable no-else-return */
  if (960 >= widthOfDisplay) {
    return true
  } else {
    return false
  }
}
